import { useState, useEffect } from "react";
import DraggableList from "../common-components/DraggableList";
import BlackButton from "../custom-components/BlackButton";
import CloseButton from "../custom-components/CloseButton";
import "../../styles/common-components/ReorderModal.css";

function ReorderModal({
  show,
  onClose,
  onSubmit,
  data,
  title = "Drag to reorder items",
}) {
  const [dragItems, setDragItems] = useState([]);

  // Prepare dragItems when data changes or modal opens
  useEffect(() => {
    if (data && data.length) {
      const orderedItems = data.map((item, index) => ({
        ...item,
        order: item.order !== undefined ? item.order : index + 1,
      }));
      setDragItems(orderedItems);
    }
  }, [data, show]);

  // Reorder utility
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // Drag end handler
  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = reorder(dragItems, result.source.index, result.destination.index);
    const updatedItems = items.map((item, idx) => ({ ...item, order: idx + 1 }));
    setDragItems(updatedItems);
  };

  // Submit handler
  const handleSubmit = () => {
    const orderedArray = dragItems.map(({ _id, name, order }) => ({
      _id,
      name,
      order,
    }));
    onSubmit(orderedArray);
  };

  if (!show) return null;

  return (
    <div className="reorder-modal">
      <div className="reorder-modal-scroll">
        <div className="reorder-modal-flex">
          <div className="reorder-modal-content">
            <div className="reorder-modal-close">
              <CloseButton onClickhandle={onClose} />
            </div>
            <h3 className="reorder-modal-title">{title}</h3>
            <DraggableList
              dataItems={dragItems}
              onDragEnd={onDragEnd}
            />
            <div className="reorder-modal-submit">
              <BlackButton onClickhandle={handleSubmit}>
                Submit
              </BlackButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReorderModal;